import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {

  private isServer = isPlatformServer(inject(PLATFORM_ID));

  public constructor() {
    if (this.isServer) {
      return;
    }

    // snipped taken from https://developers.google.com/maps/documentation/javascript/libraries
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line
    (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
      key: environment.mapsApiKey,
      v: 'weekly',
      // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
      // Add other bootstrap parameters as needed, using camel case.
    });
  }

  public async map(): Promise<google.maps.MapsLibrary> {
    return await google.maps.importLibrary('maps') as google.maps.MapsLibrary;
  }

  public async marker(): Promise<google.maps.MarkerLibrary> {
    return await google.maps.importLibrary('marker') as google.maps.MarkerLibrary;
  }

  public async geocoding(): Promise<google.maps.GeocodingLibrary> {
    return await google.maps.importLibrary('geocoding') as google.maps.GeocodingLibrary;
  }

}
